var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteFilled = function SvgFavoriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "M16.133 1.386c-2.04-1.723-5.169-1.476-7.103.528C7.06-.09 3.931-.336 1.892 1.386-.746 3.602-.36 7.224 1.54 9.158l6.154 6.294a1.86 1.86 0 0 0 1.336.563c.492 0 .95-.211 1.301-.563l6.19-6.294c1.863-1.934 2.25-5.556-.388-7.772"
  })));
};
export default SvgFavoriteFilled;